import React from "react";
import godparentsImage from "./images/godparents.webp";
import lineHeartImage from "./images/line-heart.webp";
import "./Godparents.scss";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";
/// TODO: delete
export default function Godparents() {
  return (
    <div className="p-top-8 p-bottom-8 bg-secondary" id="godparents">
      <div className="container text-center p-block-3">
        <h1 className="text-center m-bottom-4">КУМОВЕ</h1>
        <div className="relative godparents-image m-inline-auto">
          <div className="line-heart-image">
            <OnScrollAnimationWrapper
              animation={"animation-slide-fade-in-right"}
              triggerOnce={false}
              classNameInitialState={`opacity-0 animation-duration-1s animation-custom-style`}
            >
              <img src={lineHeartImage} alt="Line Heart" width="100%" height="auto" />
            </OnScrollAnimationWrapper>
          </div>
          <img src={godparentsImage} alt="Godparents" className="godparents-image-style"width="100%" height="auto" />
        </div>
        <h4 className="text-center m-bottom-4 m-top-1 font-body">сем. Иванови</h4>
      </div>
    </div>
  );
}
